import querystring from 'querystring'
import axios from 'axios'

const serverURL = 'http://api.updesignsz.com'
const devUrl = 'http://127.0.0.1:8080'
const baseURL = process.env.NODE_ENV === 'production' ? serverURL : serverURL

const http = axios.create({
  timeout: 10000,
  baseURL
})

function httpGet (url, param) {
  if (param) {
    url += '?' + querystring.stringify(param)
  }
  return http.get(url)
}

function httpPost (url, param) {
  return http.post(url, param)
}

const ChapterType = {
  project: 'project',
  contact: 'contact',
  memory: 'memory',
  member: 'member',
  about: 'about',
  news: 'news',
  job: 'job'
}

http.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  document.body.classList.add('loaded')
  return response.data
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error)
})

export {
  ChapterType,
  serverURL,
  baseURL,
  httpPost,
  httpGet,
  axios,
  http
}
